import React from 'react';
import './Times.css';

import Time from './Time';

export default props => {
  const { acompanhamento = false, times, timeSelecionado, selecionarTime, removerJogador, erro = false } = props;
  const msgErro = erro ? <p className="erroSelecao">Operação não permitida</p> : null;
  console.log('msgErro', msgErro);
  const ListaTimes =
    times.length > 0 ? (
      times
        .sort((a, b) => {
          if (a.nome > b.nome) return 1;
          if (a.nome < b.nome) return -1;
          return 0;
        })
        .map(time => (
          <Time
            acompanhamento={acompanhamento}
            key={time.id.toString()}
            id={time.id}
            nome={time.nome}
            escudo={time.escudo}
            jogadores={time.jogadores}
            selecionarTime={selecionarTime}
            removerJogador={removerJogador}
            open={timeSelecionado.nome === time.nome}
          />
        ))
    ) : (
      <p>Nenhum time no campeonato</p>
    );
  return (
    <div className="Times">
      <div className="TimesTitulo">
        <p>Equipes</p>
      </div>
      {!acompanhamento ? <div className="TimesSelecione">{timeSelecionado.nome ? msgErro : <p>Selecione uma equipe</p>}</div> : null}
      {ListaTimes}
    </div>
  );
};
